import { ExecutorRole } from '../OrderReport/ExecutorRole'

export const shouldShowHelpDeskEddyWidget = (executorRole?: number) =>
  executorRole === ExecutorRole.MENTOR
